
document.addEventListener("DOMContentLoaded", () => {
  const popup = document.getElementById("videoPopup");
  const video = document.getElementById("popupVideo");
  const overlay = document.querySelector(".video-popup-overlay");
  const closeBtn = document.querySelector(".video-popup-close");
  const playBtn = document.getElementById("videoPopup-play");

  // OPEN POPUP
  if(popup) {
    document.addEventListener("openVideoPopup", () => {
      popup.classList.add("active");
  
      // Ensure video is reset
      // video.pause();
      // video.currentTime = 0;
      // video.muted = false;
      playBtn.click();
      // playBtn.classList.remove("active");
    });
  
    // CLOSE
    function closePopup() {
      popup.classList.remove("active");
      video.pause();
      video.muted = true;
      playBtn.classList.remove("active");
    }
  
    overlay.addEventListener("click", closePopup);
    closeBtn.addEventListener("click", closePopup);
  
    // ✅ PLAY BUTTON CLICK
    playBtn.addEventListener("click", (e) => {
      e.stopPropagation(); // prevent triggering video click
  
      video.play();
      video.muted = false;
      playBtn.classList.add("active");
    });
  
    // ✅ VIDEO CLICK → PAUSE
    video.addEventListener("click", () => {
      if (video.paused) {
        video.play();
        video.muted = false;
        playBtn.classList.add("active");
      } else {
        video.pause();
        video.muted = true;
        playBtn.classList.remove("active");
      }
    });
  }
});

class PDPVideoElement extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", this.handleClick);
  }

  handleClick() {
    document.dispatchEvent(
      new CustomEvent("openVideoPopup", {
        bubbles: true,
        detail: {
          videoSrc: this.dataset.video
        }
      })
    );
  }
}

// Register (same pattern as facet-form)
if (!window.customElements.get("pdp-video-element")) {
  window.customElements.define("pdp-video-element", PDPVideoElement);
}

document.addEventListener("DOMContentLoaded", function () {
  const video = document.getElementById("popupVideo");
  if (video) {
    video.pause();
    video.currentTime = 0;
    video.removeAttribute("autoplay");
  }
});